import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { Ticket } from '../../../_interfaces/ticket';
import { TicketZeit } from '../../../_interfaces/TicketTime';
import { DarkmodeService } from '../../../_provider/darkmode.service';
import { TimeTicketBundle, ZeitenService } from '../../../_provider/zeiten.service';
import { TicketDetailPagePage } from '../../../_pages/ticket-detail-page/ticket-detail-page.page'
import { GeneralService } from 'src/app/_provider/general.service';
import { TicketEmployee} from 'src/app/_provider/tickets/ticket.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { AuthService } from 'src/app/_provider/auth.service';

@Component({
  selector: 'app-time-overview-base',
  templateUrl: './time-overview-base.page.html',
  styleUrls: ['./time-overview-base.page.scss'],
})
export class TimeOverviewBasePage implements OnInit {

  public now: Date = new Date()

  private timerSub: Subscription
  public ticketId: number = 0
  public taskId: number = 0

  constructor(
    public timesSrv: ZeitenService,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    public authService: AuthService,
    private feedback: FeedbackService
  ) { 
    this.timerSub = this.timesSrv.timer().subscribe(()=>{
      this.now = new Date()
    })
  }

  ngOnInit() {
    this.ticketId = this.navParams.get("ticketId")
    this.taskId = this.navParams.get("taskId")
  }

  ngOnDestroy(){
    this.timerSub.unsubscribe()
  }

  public async stopTime(time: TimeTicketBundle){
    if(this.taskId) if(this.timesSrv.timeTickett.filter(tt => tt.taskId == this.taskId).length == 0) await this.modalCtrl.dismiss()
    if(this.ticketId) if(this.timesSrv.timeTickett.filter(tt => tt.ticket.id == this.ticketId).length == 0) await this.modalCtrl.dismiss()
    if(this.timesSrv.timeTickett.length == 0) await this.modalCtrl.dismiss()
  }

  public async close(){
    await this.modalCtrl.dismiss(null)
  }

}
